// Text to Speech (TTS) utility functions

export async function textToSpeech(options: { text: String }) {
  // This function converts the text to speech and speaks it out loud
  return new Promise((resolve) => {
    speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(options.text.toString());

    speechSynthesis.speak(utterance);

    utterance.onend = resolve;
  });
}
